import { useMemo } from 'react';
import { AbiItem } from 'web3-utils';
import { useWeb3React } from '@web3-react/core';
import { constants, providers } from 'ethers';

import MulticallAbi from 'config/abi/Multicall.json';
import LpPairAbi from 'config/abi/LpPair.json';
import { getContract } from 'utils/address';
import Erc20 from 'config/abi/Erc20.json';

import { getMulticallAddress } from 'utils/addressHelpers';

export const useContract = (abi: AbiItem, address: string, withSignerIfPossible = true) => {
  const { account, connector } = useWeb3React();

  return useMemo(() => {
    if (!address || !abi || !connector.provider) return null;
    const provider = new providers.Web3Provider(connector.provider!);
    if (address === constants.AddressZero) {
      return null;
    }

    try {
      return getContract(address, abi, provider, withSignerIfPossible && account ? account : undefined);
    } catch (error) {
      console.error('Failed to get contract', error);
      return null;
    }
  }, [address, abi, connector, withSignerIfPossible, account]);
};

// WFTM contract
export const useWFTMContract = () => useContract(MulticallAbi as unknown as AbiItem, getMulticallAddress());

// lp token contract
export const useLpContract = (address: string) => useContract(LpPairAbi as unknown as AbiItem, address);

// nft token contract
export const useToken = (address: string) => useContract( Erc20 as unknown as AbiItem, address);

export default useContract;
